import { actions, kea, path, reducers } from 'kea'

import { bindModalToUrl } from 'lib/logic/bindModalToUrl'

import type { globalModalsLogicType } from './globalModalsLogicType'

export const globalModalsLogic = kea<globalModalsLogicType>([
    path(['layout', 'navigation', 'globalModalsLogic']),
    actions({
        showCreateOrganizationModal: true,
        hideCreateOrganizationModal: true,
        showCreateProjectModal: true,
        hideCreateProjectModal: true,
    }),
    reducers({
        isCreateOrganizationModalShown: [
            false,
            {
                showCreateOrganizationModal: () => true,
                hideCreateOrganizationModal: () => false,
            },
        ],
        isCreateProjectModalShown: [
            false,
            {
                showCreateProjectModal: () => true,
                hideCreateProjectModal: () => false,
            },
        ],
    }),
    bindModalToUrl({
        urlKey: 'create-organization',
        openActionKey: 'showCreateOrganizationModal',
        closeActionKey: 'hideCreateOrganizationModal',
        isOpenKey: 'isCreateOrganizationModalShown',
    }),
])
